<app-loader
	[enableCircle]="true"
	[isActive]="this.isLoading$ | async"
	[width]="20"
></app-loader>
<mat-dialog-content>
	<form
		(submit)="$event.preventDefault()"
		[formGroup]="this.insertGrp"
		#form="ngForm"
	>
		<div tg-form-field>
			<div tg-form-field-label>Name</div>
			<div tg-container>
				<input
					formControlName="name"
					tg-input
					type="text"
				>
				<div class="tg-input-suffix flex flex-row items-center justify-content- mx-1">
					<mat-divider
						class="mr-1"
						style="width: 1px; height: 18px"
						vertical
					></mat-divider>
					<button
						(click)="resetTaskName()"
						class="mat-button-icon-sm"
						mat-icon-button
					>
						<mat-icon inline>restore</mat-icon>
					</button>
				</div>
			</div>
			<small
				*ngIf="this.insertGrp.controls.name.errors?.minlength"
				class="text-warn mt-1 tg-hint"
			>
				{{ 'errors.minlength' | translate: { field: 'Name', length: 3 } }}
			</small>
		</div>
		<ng-container *ngIf="this.daySelector$ | async as daySelector">
			<div tg-form-field>
				<div tg-form-field-label>{{ 'feed.chain-event' | translate }}</div>
				<div tg-container>
					<mat-select
						[compareWith]="selectedDayCompare"
						class="tg-select"
						formControlName="selectedDay"
						placeholder="Select Day"
					>
						<mat-option
							[value]="day"
							*ngFor="let day of daySelector; trackBy: day?.toString()"
						>
							{{ day.format('LL') }}
						</mat-option>
					</mat-select>
				</div>
			</div>
		</ng-container>
		<div class="tg-form-field flex flex-col">
			<div class="flex flex-row items-center justify-between">
				<app-time-input
					(click)="$event.stopPropagation(); this.selectInput($event, startInpRef)"
					(focus)="this.selectInput($event, startInpRef)"
					(keydown.enter)="$event.preventDefault()"
					[displayFormat]="false"
					[inputClass]="'tg-input tg-input-sm tg-input-center'"
					[inputPlaceholder]="'timer.time.start' | translate"
					[maxlength]="5"
					[style.width.px]="74"
					#startInpRef="nativeElement"
					#tStartFormField
					elementRef
					formControlName="start"
					tg-container
				></app-time-input>
				<span class="tg-seperator mx-2"> <mat-icon>arrow_forward</mat-icon> </span>
				<app-time-input
					(click)="$event.stopPropagation(); this.selectInput($event, endInpRef)"
					(focus)="this.selectInput($event, endInpRef)"
					(keydown.enter)="$event.preventDefault()"
					[displayFormat]="false"
					[inputClass]="'tg-input tg-input-sm tg-input-center'"
					[inputPlaceholder]="'timer.time.end' | translate"
					[maxlength]="5"
					[style.width.px]="74"
					#endInpRef="nativeElement"
					#tEndFormField
					elementRef
					formControlName="end"
					tg-container
				></app-time-input>
			</div>
			<small
				*ngIf="this.insertGrp.errors?.range"
				class="text-warn mt-1"
			>
				{{ 'errors.record.time-invalid-range' | translate }}</small
			>
		</div>
		<div class="flex flex-row items-center">
			<mat-checkbox
				color="primary"
				formControlName="billable"
			>
				{{ 'Billable' | translate }}
			</mat-checkbox>
			<div class="flex-grow"></div>
			<button
				(click)="onSubmit()"
				[disabled]="this.insertGrp?.invalid || (this.isLoading$ | async)"
				color="primary"
				mat-raised-button
			>
				{{ 'feed.entry.save' | translate }}
			</button>
		</div>
	</form>
</mat-dialog-content>
